<template>
  <div>
    <title-component :size="1" :lineSeparator="'under'">
      <translate>Welcome to Kiwa Certification</translate>
    </title-component>
    <div class="columns section-bordered">
      <!-- Right panel -->
      <div class="column is-6">
        <title-component :size="4">
          <translate>Create or recover password</translate>
          <template slot="subtitle">
            <translate>
              Enter the email address you registered in the portal. If you have received an email from the portal,
              use the address to which the portal mail was sent.
            </translate>
            <p>
              <strong><translate>Don't know which email address is registered?</translate></strong>
              <router-link :to="{ name: 'ResetPasswordSSNView' }" class="link" v-translate>
                Click here
              </router-link>
              <translate>to reset your password using your social security number.</translate>
            </p>
          </template>
        </title-component>
        <message-component v-if="showSuccess" class="message" :level="'success'">
          <translate> An email has been sent to your registered address if it was found.</translate>
        </message-component>
        <!-- Reset password form -->
        <template v-if="formDescriptors && formDatas">
          <form-component
            v-for="formDescriptor in formDescriptors"
            :formDescriptor="formDescriptor"
            :formData="getFormDataForDescriptor(formDescriptor)"
            :key="formDescriptor.id"
            class="reset-password-form">
          </form-component>
        </template>
        <!-- Non field error handling -->
        <transition
          name="fade"
          appear
          appear-active-class="animated fadeIn"
          enter-active-class="animated fadeIn"
          leave-active-class="animated fadeOut"
          :duration="{ enter: 200, leave: 200 }">
          <div v-if="mixin.error" class="notification is-danger">
            {{ mixin.error }}
          </div>
        </transition>

        <div class="btn-container">
          <submit-btn-component
            ref="enterButton"
            class="is-primary submit-button is-large is-uppercase center-vertically"
            @submit="submitSaveResetPasswordForm"
            v-translate>
            Send password
          </submit-btn-component>
        </div>
      </div>
    </div>
    <!-- Browser compatiblity check -->
    <browser-compatibility-component />
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import FormComponent from '@/components/form/FormComponent'
  import TitleComponent from '@/components/layout/TitleComponent.vue'
  import { formHandlerMixin, onKeyEnterMixin, setContainedHeightMixin } from '@/mixins/mixins'
  import SubmitBtnComponent from '@/components/layout/utility/SubmitBtnComponent.vue'
  import BrowserCompatibilityComponent from '@/components/layout/BrowserCompatibilityComponent'
  import MessageComponent from '@/components/layout/utility/MessageComponent'

  export default {
    name: 'reset-password-view',
    mixins: [onKeyEnterMixin, formHandlerMixin, setContainedHeightMixin],
    data () {
      return {
        submitRequest: null,
        showSuccess: false
      }
    },
    components: {
      TitleComponent,
      SubmitBtnComponent,
      FormComponent,
      BrowserCompatibilityComponent,
      MessageComponent
    },
    computed: {
      ...mapState({
        formDescriptors: state => state.authModule.formDescriptors,
        formDatas: state => state.authModule.formDatas
      })
    },
    methods: {
      ...mapActions([
        'setupResetPasswordForm',
        'saveResetPasswordForm',
        'clearData'
      ]),
      submitSaveResetPasswordForm (btn) {
        this.mixin.error = null
        this.showSuccess = false
        let requestData = {
          formDatas: this.formDatas
        }
        this.submitRequest = this.saveResetPasswordForm
        this.submitForm(requestData, btn, () => {
          this.showSuccess = true
        })
      }
    },
    created () {
      this.setupResetPasswordForm().catch((err) => {
        this.handleError(err)
      })
    },
    beforeDestroy () {
      this.clearData()
    }
  }
</script>

<style lang="sass" scoped>
  .reset-password-form
    margin-top: 0
  .btn-container
    margin: 1rem 0
  .link
    display: inline-block
    margin: 0 0.5rem
</style>
